var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9594 8.67622C10.217 8.67622 9.41265 8.55247 8.73207 8.30499C8.6702 8.30499 8.60833 8.30499 8.54646 8.30499C8.36085 8.30499 8.23711 8.36686 8.11337 8.4906L6.75221 9.85176C5.01983 8.9237 3.53494 7.50067 2.66875 5.76829L4.0299 4.40714C4.21552 4.22153 4.27739 3.97405 4.15365 3.78843C3.96803 3.10786 3.84429 2.30354 3.84429 1.56109C3.84429 1.25174 3.53494 0.942383 3.22559 0.942383H1.06011C0.75076 0.942383 0.441406 1.25174 0.441406 1.56109C0.441406 7.37693 5.14358 12.0791 10.9594 12.0791C11.2688 12.0791 11.5781 11.7697 11.5781 11.4604V9.29492C11.5781 8.98557 11.2688 8.67622 10.9594 8.67622ZM1.67882 2.1798H2.60688C2.66875 2.73663 2.79249 3.29347 2.91623 3.78843L2.17378 4.53088C1.9263 3.78843 1.74069 2.98411 1.67882 2.1798ZM10.3407 10.8417C9.53639 10.7798 8.73207 10.5942 7.98963 10.3467L8.73207 9.60427C9.22704 9.72802 9.78388 9.85176 10.3407 9.85176V10.8417Z",
    fill: "#FFBA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ad9c3353a8e0ac6dcb76a4edc8d9798d.svg";
export { ForwardRef as ReactComponent };